// settings-import-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'sim.appr.unnamed': 'Unnamed',
  'sim.appr.document': 'Document',
  'sim.appr.historyLine': 'History line',
  'sim.appr.openingBalanceYear': 'Opening balance {year}',
  'sim.appr.debitCredit': 'Debit {debit} / Credit {credit}',
  'sim.appr.voucherCount': '{count} vouchers',
  'sim.appr.account': 'Account',
  'sim.appr.inactive': 'inactive',
  'sim.appr.debitCreditLines': 'Debit {debit} / Credit {credit} - {count} account lines',
  'sim.appr.salesOutstanding': 'Sales {sales} · Outstanding {outstanding}',
  'sim.appr.purchasesOutstanding': 'Purchases {purchases} · Outstanding {outstanding}',
  'sim.appr.noExtraDetails': 'No additional details',
  'sim.appr.statSales': 'sales {amount}',
  'sim.appr.statOutstanding': 'outst. {amount}',
  'sim.appr.statPurchases': 'purchases {amount}',
  'sim.appr.openingBalanceLine': '{year}: {count} lines - debit {debit} / credit {credit}',
  'sim.appr.previewShown': 'showing {shown} of {total} {label}',
  'sim.appr.limitDocuments': 'The document archive shows {shown} of {total} files. The full archive is in the original export package.',
  'sim.appr.limitLedger': 'The ledger archive shows {shown} of {total} history lines. The full history is in the original export package.',
  'sim.appr.importing': 'Importing...',
  'sim.appr.approveImport': 'Approve import',
  'sim.appr.warningsTitle': 'Warnings from the import analysis',
  'sim.appr.willImport.title': 'Imported when you approve',
  'sim.appr.willImport.registers': 'Customers, suppliers and products are updated in the registers.',
  'sim.appr.willImport.balances': 'Balance accounts and opening balances are entered per year.',
  'sim.appr.willImport.bankAccounts': 'Bank accounts from imported account names are linked to the accounting setup.',
  'sim.appr.history.title': 'Saved as history/follow-up',
  'sim.appr.history.sums': 'Customer and supplier totals are shown in the registers.',
  'sim.appr.history.ledgerBalance': 'Outstanding subledger balances are shown where SAF-T has a balance per party.',
  'sim.appr.history.openItems': 'Open items, document archive and ledger history are saved as import basis data, not as posted vouchers.',
  'sim.appr.notImported.title': 'Not imported automatically',
  'sim.appr.notImported.ledger': 'The historical ledger is not posted as live entries.',
  'sim.appr.notImported.documents': 'Imported documents are not analysed or posted automatically.',
  'sim.appr.updatesText': 'This updates customers, suppliers, opening balances and only the accounts needed for balances. Historical vouchers and entries are not posted automatically.',
  'sim.appr.archiveDocsLabel': 'archive documents',
  'sim.appr.limitedPreview': 'Limited preview',
  'sim.appr.productCollision.title': 'Product number already exists',
  'sim.appr.productCollision.text': 'Plumme keeps the existing product by default. Tick the box if the imported product should be included too; it then gets a new item number with an import key and can be deleted from Products later.',
  'sim.appr.importedProduct': 'Imported product',
  'sim.appr.existingProduct': 'existing product',
  'sim.appr.sameKey': 'same key',
  'sim.appr.importAsOwn': 'Import "{name}" as a separate product',
  'sim.appr.productExists': 'Product number {number} already exists as "{existing}". On approval the imported product gets a new item number, for example IMP-{number}.',
  'sim.appr.invoiceCollision.title': 'Invoice number already exists',
  'sim.appr.invoiceCollision.text': 'The regulations require sales documents to have a verifiable, unbroken number series in the system they were issued from. These invoices come from a previous system and are therefore stored as read-only import history in Plumme. They do not overwrite new Plumme invoices and are not posted again as live invoices.',
  'sim.appr.invoiceLabel': 'Invoice {number}',
  'sim.appr.moreCount': '+ {count} more',
  'sim.appr.invoiceCollision.accept': 'I understand that these invoices are imported as history, not as new Plumme invoices.',
  'sim.appr.panel.products': 'Products',
  'sim.appr.panel.productsEmpty': 'No products suggested',
  'sim.appr.panel.customerStats': 'Customer statistics',
  'sim.appr.panel.customerStatsEmpty': 'No customer statistics found',
  'sim.appr.panel.supplierStats': 'Supplier statistics',
  'sim.appr.panel.supplierStatsEmpty': 'No supplier statistics found',
  'sim.appr.panel.openCustomerInvoices': 'Open customer invoices',
  'sim.appr.panel.openCustomerInvoicesEmpty': 'No open customer invoices found',
  'sim.appr.panel.openSupplierInvoices': 'Open supplier invoices',
  'sim.appr.panel.openSupplierInvoicesEmpty': 'No open supplier invoices found',
  'sim.appr.panel.openingBalances': 'Opening balance',
  'sim.appr.panel.openingBalancesEmpty': 'No opening balances found',
  'sim.appr.panel.documents': 'Document archive',
  'sim.appr.panel.documentsEmpty': 'No archive documents found',
  'sim.appr.panel.ledger': 'Ledger archive',
  'sim.appr.panel.ledgerEmpty': 'No history lines found',
  'sim.appr.bankReadyOne': '{count} account is ready',
  'sim.appr.bankReadyMany': '{count} accounts are ready',
  'sim.appr.bankMissing': '{missing} of {total} are missing a reconciliation date',
  'sim.appr.bankDone': 'Opening balance and reconciled-through date are set.',
  'sim.appr.bankTodo': 'Set the opening balance and "reconciled through" date before the import can be approved.',
  'sim.appr.panel.accounts': 'Accounts',
  'sim.appr.panel.accountsEmpty': 'No balance accounts suggested',
  'sim.appr.panel.customers': 'Customers',
  'sim.appr.panel.customersEmpty': 'No customers suggested',
  'sim.appr.panel.suppliers': 'Suppliers',
  'sim.appr.panel.suppliersEmpty': 'No suppliers suggested',
  'sim.appr.afterText': 'You can cancel here, check the latest analysis on the page behind and open the approval again. Check the opening balance before you use the figures further.',
  'sim.appr.bank.title': 'Bank accounts from the import',
  'sim.appr.bank.whereTitle': 'Where does Plumme take over?',
  'sim.appr.bank.whereText': '"Reconciled through" is the date the bank was last reconciled in the old system. Plumme treats everything before that date as settled there and only starts requiring bank statements the day after. The opening balance is the balance at the end of exactly this date – not today\'s balance or the latest balance in the import file.',
  'sim.appr.bank.kindTax': 'Tax withholding',
  'sim.appr.bank.kindOperating': 'Operating',
  'sim.appr.bank.ready': 'Ready',
  'sim.appr.bank.confirmBalance': 'I have checked the date and balance against the bank.',
  'sim.appr.bank.reviewRequired': 'Review required',
  'err.import.bankReviewRequired': 'Review and confirm the reconciliation date and balance for every imported bank account.',
  'sim.appr.bank.missingDate': 'Missing date',
  'sim.appr.bank.lastReconciled': 'Last reconciled in the old system',
  'sim.appr.bank.balanceAtDate': 'Balance at the end of this date',
  'sim.appr.detail.search': 'Search {label}',
  'sim.appr.detail.shown': '{shown} of {total} shown',
  'sim.imp.intro': 'Upload a complete export package, or select several files at once: SAF-T, CSV and Excel. Plumme analyses the content first, and you approve what is actually imported.',
  'sim.imp.elapsedMinSec': '{min} min {sec} sec',
  'sim.imp.elapsedSec': '{sec} sec',
  'sim.imp.step.uploading': 'Uploading the export package',
  'sim.imp.step.analyzing': 'Analysing SAF-T, Excel and voucher folders',
  'sim.imp.step.ready': 'Ready for approval of basis data',
  'sim.imp.step.committed': 'Basis data has been imported',
  'sim.imp.title.error': 'The import stopped',
  'sim.imp.title.committed': 'Basis data import completed',
  'sim.imp.title.analyzed': 'Import analysis finished',
  'sim.imp.title.running': 'Importing complete accounting data',
  'sim.imp.exportPackage': 'Export package',
  'sim.imp.elapsed': 'elapsed {time}',
  'sim.imp.uploadedOf': '{sent} of {total} uploaded.',
  'sim.imp.analyzingHelp': 'Large export packages and file sets can take several minutes. Keep the tab open while Plumme finds SAF-T, CSV, Excel files and voucher folders.',
  'sim.imp.committingHelp': 'Plumme is updating the chart of accounts, customers, suppliers and opening balance. Do not press more than once.',
  'sim.imp.analyzeFailed': 'Could not analyse the export package.',
  'sim.imp.foundFiles': 'Found {count} files',
  'sim.imp.foundBreakdown': '{saft} SAF-T, {excel} Excel, {csv} CSV and {vouchers} voucher files.',
  'sim.imp.dontClose': 'Do not close the tab while the import is running. You can continue when the analysis is finished and the basis data is shown for approval.',
  'sim.set.notConnected': '{label} is not connected in Plumme yet.',
});
